import { render, staticRenderFns } from "./SolanJournalsPure.vue?vue&type=template&id=a167423c&scoped=true&"
import script from "./SolanJournalsPure.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsPure.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsPure.vue?vue&type=style&index=0&id=a167423c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167423c",
  null
  
)

export default component.exports